import React from 'react'

import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import OutOfStockProductsList from '@shared/out_of_stock_products/OutOfStockProductsList'
import ListPageHeader from '@shared/ListPageHeader'

import brandService from '@services/operator/brandService'
import { outOfStockProductService } from '@services/operator/outOfStockProductService'

export default function OperatorOutOfStockProductsList() {
  const { merchants, salesChannels } = useOperatorData()

  return (
    <div>
      <ListPageHeader items={['orders', 'orders.out_of_stock']} />
      <OutOfStockProductsList
        service={outOfStockProductService}
        brandService={brandService}
        role="operator"
        merchants={merchants}
        salesChannels={salesChannels}
      />
    </div>
  )
}
